import React from 'react';
import { Navigate } from 'react-router-dom';
const LoginNavigationComponent = ({ step, queryString }) => {
    const url = `/referral/cx/login${queryString}`;
    if (step === 1) {
        return (
            <Navigate
                to={url}
            />
        );
    }
    return null;
}
export default LoginNavigationComponent;